import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-div-contactgegevens',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-contactgegevens.component.html',
  styleUrl: './tekst-contactgegevens.component.scss',
})
export class TekstContactgegevensComponent {}
